import { render } from "./BeneficiaryDetailsModal.vue?vue&type=template&id=2c79c1bb&scoped=true"
import script from "./BeneficiaryDetailsModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetailsModal.vue?vue&type=script&lang=js"

import "./BeneficiaryDetailsModal.vue?vue&type=style&index=0&id=2c79c1bb&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c79c1bb"]])

export default __exports__